module.exports = __webpack_public_path__ + "img/zz.810e8240.png";